// import React, { useEffect, useState } from "react";
// import { Table, Button, Upload, message, Input } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import * as XLSX from "xlsx";
// import dataService from "../networks/api/service/dataService";
// import CustomTable from "./TableComponent/CustomTable";

// function ElectionFileUpload({ getExcelData, resetTable }) {
//   const [uploadedData, setUploadedData] = useState([]); // Data from uploaded file
//   const [columns, setColumns] = useState([]); // Dynamic columns based on headers

//   // Handle cell edits with an explicit state update
//   const handleEditCell = (value, rowIndex, columnKey) => {
//     setUploadedData((prevData) =>
//       prevData.map((row, idx) =>
//         idx === rowIndex ? { ...row, [columnKey]: value } : row
//       )
//     );
//   };

//   useEffect(() => {
//     if (resetTable) {
//       resetTableData();
//     }
//   }, [resetTable]);

//   const resetTableData = () => {
//     setUploadedData([]);
//     setColumns([]);
//   };

//   // Define columns dynamically based on uploaded file headers
//   const generateColumns = (headers) => {
//     return headers.map((header) => ({
//       title: header,
//       dataIndex: header,
//       key: header,
//       render: (text, record, index) => (
//         <Input
//           value={record[header]}
//           // onChange={(e) => handleEditCell(e.target.value, index, header)}
//           style={{
//             width: "100%",
//             border: "1px solid #d9d9d9",
//             padding: "4px",
//             borderRadius: "4px",
//           }}
//         />
//       ),
//     }));
//   };

//   // Handle file upload
//   const handleFileUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//       // Find the row that contains "SL NO" to identify the headers
//       const headerRowIndex = parsedData.findIndex((row) =>
//         row.includes("SL NO")
//       );

//       if (headerRowIndex === -1) {
//         message.error("SL NO column not found in the uploaded file.");
//         return false;
//       }

//       // Extract headers and data starting from the identified header row
//       const headers = parsedData[headerRowIndex];
//       const dataRows = parsedData.slice(headerRowIndex + 1);

//       // Format data into objects using headers
//       const formattedData = dataRows.map((row, index) => {
//         const rowObject = headers.reduce((acc, header, colIndex) => {
//           acc[header] = row[colIndex] || ""; // Default empty if no value
//           return acc;
//         }, {});
//         rowObject.key = index; // Assign unique key
//         return rowObject;
//       });

//       setColumns(generateColumns(headers)); // Set columns based on headers
//       console.log(formattedData, "formattedData");
//       setUploadedData(formattedData); // Set table data
//     };
//     reader.readAsArrayBuffer(file);
//     return false; // Prevent default upload behavior
//   };

//   // Save data as an Excel file and send to server
//   // const saveAllUploadedData = async () => {
//   //   // Convert JSON data to worksheet
//   //   const worksheet = XLSX.utils.json_to_sheet(uploadedData);
//   //   // Create a new workbook and append the worksheet
//   //   const workbook = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(workbook, worksheet, "Edited Data");

//   //   // Generate binary Excel file
//   //   const excelBuffer = XLSX.write(workbook, {
//   //     bookType: "xlsx",
//   //     type: "array",
//   //   });

//   //   // Create a Blob from the buffer and prepare it for upload
//   //   const blob = new Blob([excelBuffer], {
//   //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   //   });
//   //   const formData = new FormData();
//   //   formData.append("file", blob, "EditedData.xlsx");
//   //   console.log(formData, "formData");
//   //   getExcelData(formData);
//   //   // uploadBulkData(formData);
//   //   // XLSX.writeFile(workbook, "EditedData.xlsx"); // download Excel
//   // };

//   const saveAllUploadedData = async () => {
//     getExcelData(uploadedData);
//   };

//   const uploadBulkData = async (formData) => {
//     const res = await dataService.uploadBulkConstituency(formData);
//   };

//   return (
//     <div>
//       <Upload
//         beforeUpload={handleFileUpload}
//         accept=".xlsx, .xls"
//         showUploadList={false}
//       >
//         <Button icon={<UploadOutlined />}>Upload Excel File</Button>
//       </Upload>

//       {uploadedData.length > 0 && (
//         <div style={{ marginTop: 20 }}>
//           <h3>Uploaded Data </h3>
//           <CustomTable
//             dataSource={uploadedData}
//             columns={columns}
//             rowKey="key"
//             pagination={true}
//             bordered
//             size="middle"
//             style={{
//               boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//               borderRadius: "8px",
//               backgroundColor: "#fff",
//               width: "100%",
//               overflowX: "auto",
//             }}
//             scroll={{ x: 800 }}
//           />
//           <Button
//             type="primary"
//             onClick={saveAllUploadedData}
//             style={{ marginTop: 10 }}
//           >
//             Upload Data
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ElectionFileUpload;

// import React, { useEffect, useState } from "react";
// import { Table, Button, Upload, message, Input } from "antd";
// import { UploadOutlined } from "@ant-design/icons";
// import * as XLSX from "xlsx";
// import dataService from "../networks/api/service/dataService";
// import CustomTable from "./TableComponent/CustomTable";

// function ElectionFileUpload({ getExcelData, resetTable }) {
//   const [uploadedData, setUploadedData] = useState([]);
//   const [columns, setColumns] = useState([]);

//   useEffect(() => {
//     if (resetTable) {
//       resetTableData();
//     }
//   }, [resetTable]);

//   const resetTableData = () => {
//     setUploadedData([]);
//     setColumns([]);
//   };

//   // Define columns dynamically with conditional styling
//   const generateColumns = (headers) => {
//     return headers.map((header) => ({
//       title: header,
//       dataIndex: header,
//       key: header,
//       render: (text, record) => {
//         let cellStyle = {};

//         // Conditional styling for 'rank'
//         if (header.toLowerCase() === "rank") {
//           if (text === 1) cellStyle = { backgroundColor: "gold" };
//           else if (text === 2) cellStyle = { backgroundColor: "yellow" };
//           else if (text === 3) cellStyle = { backgroundColor: "red" };
//         }

//         // Conditional styling for 'percentage'
//         if (header.toLowerCase() === "%") {
//           const percentageValue = parseFloat(text); // Ensure numeric comparison
//           if (percentageValue < 30) cellStyle = { backgroundColor: "red" };
//           else if (percentageValue < 45)
//             cellStyle = { backgroundColor: "yellow" };
//           else cellStyle = { backgroundColor: "gold" };
//         }

//         return (
//           <div
//             style={{
//               ...cellStyle,
//               padding: "8px",
//               borderRadius: "4px",
//               textAlign: "center",
//             }}
//           >
//             {text}
//           </div>
//         );
//       },
//     }));
//   };

//   // Handle file upload
//   const handleFileUpload = (file) => {
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       const data = new Uint8Array(e.target.result);
//       const workbook = XLSX.read(data, { type: "array" });
//       const sheet = workbook.Sheets[workbook.SheetNames[0]];
//       const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

//       const headerRowIndex = parsedData.findIndex((row) =>
//         row.includes("SL NO")
//       );

//       if (headerRowIndex === -1) {
//         message.error("SL NO column not found in the uploaded file.");
//         return false;
//       }

//       const headers = parsedData[headerRowIndex];
//       const dataRows = parsedData.slice(headerRowIndex + 1);

//       const formattedData = dataRows.map((row, index) => {
//         const rowObject = headers.reduce((acc, header, colIndex) => {
//           acc[header] = row[colIndex] || "";
//           return acc;
//         }, {});
//         rowObject.key = index;
//         return rowObject;
//       });

//       setColumns(generateColumns(headers));
//       setUploadedData(formattedData);
//     };
//     reader.readAsArrayBuffer(file);
//     return false;
//   };

//   const saveAllUploadedData = async () => {
//     getExcelData(uploadedData);
//   };

//   return (
//     <div>
//       <Upload
//         beforeUpload={handleFileUpload}
//         accept=".xlsx, .xls"
//         showUploadList={false}
//       >
//         <Button icon={<UploadOutlined />}>Upload Excel File</Button>
//       </Upload>

//       {uploadedData.length > 0 && (
//         <div style={{ marginTop: 20 }}>
//           <h3>Uploaded Data</h3>
//           <CustomTable
//             dataSource={uploadedData}
//             columns={columns}
//             rowKey="key"
//             pagination={true}
//             bordered
//             size="middle"
//             style={{
//               boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
//               borderRadius: "8px",
//               backgroundColor: "#fff",
//               width: "100%",
//               overflowX: "auto",
//             }}
//             scroll={{ x: 800 }}
//           />
//           <Button
//             type="primary"
//             onClick={saveAllUploadedData}
//             style={{ marginTop: 10 }}
//           >
//             Upload Data
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ElectionFileUpload;

import React, { useEffect, useState } from "react";
import { Table, Button, Upload, message, Input } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import dataService from "../networks/api/service/dataService";
import CustomTable from "./TableComponent/CustomTable";

function ElectionFileUpload({ getExcelData, resetTable }) {
  const [uploadedData, setUploadedData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (resetTable) {
      resetTableData();
    }
  }, [resetTable]);

  const resetTableData = () => {
    setUploadedData([]);
    setColumns([]);
  };

  const generateColumns = (headers) => {
    return headers.map((header, colIndex) => ({
      title: header,
      dataIndex: header,
      key: header,
      render: (text, record) => (
        <div
          style={{
            backgroundColor: record[`${header}_bgColor`] || "transparent",
            padding: "8px",
            textAlign: "center",
          }}
        >
          {text}
        </div>
      ),
    }));
  };

  const handleFileUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellStyles: true });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      const headerRowIndex = parsedData.findIndex((row) =>
        row.includes("SL NO")
      );

      if (headerRowIndex === -1) {
        message.error("SL NO column not found in the uploaded file.");
        return false;
      }

      const headers = parsedData[headerRowIndex];
      const dataRows = parsedData.slice(headerRowIndex + 1);

      const formattedData = dataRows.map((row, rowIndex) => {
        const rowObject = {};
        headers.forEach((header, colIndex) => {
          const cellAddress = XLSX.utils.encode_cell({
            r: rowIndex + headerRowIndex + 1,
            c: colIndex,
          });
          const cell = sheet[cellAddress] || {};
          rowObject[header] = row[colIndex] || "";
          rowObject[`${header}_bgColor`] = cell.s?.fgColor?.rgb
            ? `#${cell.s.fgColor.rgb}`
            : null;
        });
        rowObject.key = rowIndex;
        return rowObject;
      });

      setColumns(generateColumns(headers));
      setUploadedData(formattedData);
    };

    reader.readAsArrayBuffer(file);
    return false;
  };

  const saveAllUploadedData = async () => {
    getExcelData(uploadedData);
  };

  return (
    <div>
      <Upload
        beforeUpload={handleFileUpload}
        accept=".xlsx, .xls"
        showUploadList={false}
      >
        <Button icon={<UploadOutlined />}>Select Excel File</Button>
      </Upload>

      {uploadedData.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h3>Uploaded Data</h3>
          <CustomTable
            dataSource={uploadedData}
            columns={columns}
            rowKey="key"
            pagination={true}
            bordered
            size="middle"
            style={{
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              backgroundColor: "#fff",
              width: "100%",
              overflowX: "auto",
            }}
            scroll={{ x: 800 }}
          />
          <Button
            type="primary"
            onClick={saveAllUploadedData}
            style={{ marginTop: 10 }}
          >
            Upload Data
          </Button>
        </div>
      )}
    </div>
  );
}

export default ElectionFileUpload;
